import { fetcher } from '@commenda/utils';
import { TEMPLATE_CATEGORIES_URL } from './helpers';
import { TDocumentAssemblerUpdateTemplateCategoryParams } from './types';

export const updateDocumentAssemblerTemplateCategory = async (
  categoryId: string,
  data: TDocumentAssemblerUpdateTemplateCategoryParams
): Promise<Response> => {
  const res = await fetcher(`${TEMPLATE_CATEGORIES_URL}/${categoryId}`, {
    method: 'POST',
    body: data,
  });
  return res;
};
